import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { QRDocument, Const, Static } from '@app/shared';


@Injectable()
export class QRDocumentsPageDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;


  /**
   * Metodo que devuelve la informacion del documento
   *
   * @param {string} code
   * @return {*}  {Observable<QRDocument>}
   * @memberof QRDocumentsPageDataService
   */
  getQRdocument(code: string): Observable<QRDocument> {
    return new Observable(obs => {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.QRDocument;
      //   this.http.skipErrorHandler().post<QRDocument>(this.api.get('externalPublication',data)).subscribe(
      //   data => {
      //     obs.next(data);
      //   },
      //   err => {
      //     obs.error(err);
      //   }
      // );
      this.http
        .skipErrorHandler()
        .post<any>(this.api.addParams(path, 'simple', []), {"codigo":code}, {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo en generación de código');
            }
            obs.error(err);
          }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/qr-documents-page/shared/qr-documents-page.data.service.ts